<template>
    <div class="animated fade-in">

        <h1 class="display-4 font-weight-lighter">Current Orders</h1>

        <order-table :current="true"></order-table>

    </div>
</template>

<script>
  import OrderTable from "../../components/order/OrderTable";

  export default {
    name: 'OrderCurrent',
    components: {OrderTable}
  }
</script>